import * as React from "react";
import SearchInstallations from "../../features/SearchInstallations";
import BaseLayout from "../../components/BaseLayout";

function SearchInstallationsPage() {
  return (
    <BaseLayout paddingTop>
      <SearchInstallations searchType={"installation"} />
    </BaseLayout>
  );
}

export default SearchInstallationsPage;
